import * as React from "react";
import { observer } from "mobx-react";
import { TextField, createStyles, withStyles, Grid, Button, Typography, IconButton } from '@material-ui/core';
import { config } from 'src/config';
import { authStore } from 'src/modules/auth';
import { usersAdminStore } from '..';
import { ArrowBack } from "@material-ui/icons"; // C-012

const styles = createStyles({
    root: {
        width: "100%",
        height: "100%",
        margin: "0 auto",
        // padding: "1.5rem",
        display: "flex",
        flexDirection: "column",
    },
    rowContainer: {
        width: "100%",
        display: "flex",
        alignContent: "center",
        margin: "0 auto",
        // padding: "3rem",
    },
    columnContainer: {
        width: "100%",
        display: "flex",
        margin: "0 auto",
        // padding: "3rem",
    },
    textField: {
        display: "flex",
        paddingRight: "24px",
    },
    roleSelect: {
        minWidth: "9rem",
    },
    companySelect: {
        minWidth: "16.5rem",
    },
    appRoleSelect: {
        minWidth: "16.5rem",
        paddingTop: "1.5rem",
    },
    formContainer: {
        width: "100%",
        padding: "1.5rem",
    },
    submitContainer: {
        width: "100%",
        display: "flex",
        flexDirection: "row-reverse",
    },
    // submitButton: {
    //   backgroundColor: "#2A2A55",
    //   border: "1px solid #2D4D73",
    //   color: "#FAFAFA",
    // },
});

@observer
class ChangeUserPassword extends React.Component<any> {

    public state = {
        password: '',
        passwordConfirm: ''
    }

    public componentWillMount = async () => {
        await usersAdminStore.getAuthByID(this.props.match.params.id);
    }

    public handleInput = (property: string) => (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        this.state[property] = e.target.value;
    }

    public checkFieldsEqual = () => {
        if (this.state.password === this.state.passwordConfirm) {
            return true;
        }
        return false;
    }

    public submit = async () => {
        await usersAdminStore.changeUserPassword(usersAdminStore.current_user.auth_id, this.state.password);
        this.props.history.push('/admin/users/edit/' + usersAdminStore.current_user.auth_id);
    }

    public getHelperInfo = () => {
        let str = " ";
        if (!this.checkFieldsEqual()) {

            str += "Passwords must match. "
        }
        if (this.state.password.length < 4) {
            str += "Password must be at least 4 characters"
        }
        return str
    }

    //C-012
    public backToPage = () => {
        this.props.history.push('/admin/users/edit/' + usersAdminStore.current_user.auth_id);
    }

    public render() {
        const { classes } = this.props;
        return (
            <Grid container={true} direction="column">
                <Grid
                    container={true}
                    direction="row"
                    classes={{ container: classes.rowContainer }}
                    spacing={24}
                >
                    <Grid item={true} xs={6}>
                        {/* C-012 */}
                        <div style={{ display: 'flex' }}>
                            <IconButton onClick={this.backToPage} className={classes.leftButton}>
                                <ArrowBack />
                            </IconButton>
                            <Typography variant='h4'>Change User Password</Typography>
                        </div>
                        <Typography variant='body1'>Username : {usersAdminStore?.current_user?.FirstName + " " + usersAdminStore?.current_user?.LastName}</Typography>
                        <br />
                        <TextField
                            label="Password"
                            classes={{ root: classes.textField }}
                            value={this.state.password}
                            InputLabelProps={{ shrink: true }}
                            error={!this.checkFieldsEqual() || this.state.password.length < 4}
                            helperText={
                                this.getHelperInfo()
                            }
                            type="password"
                            required={true}
                            // onChange={this.handleInput("password")}
                            // tslint:disable-next-line: jsx-no-lambda
                            onChange={(e) => this.setState({ password: e.target.value })}
                        />
                    </Grid>
                    <Grid item={true} xs={6} />
                    <Grid item={true} xs={6}>
                        <TextField
                            label="Password Confirm"
                            classes={{ root: classes.textField }}
                            value={this.state.passwordConfirm}
                            InputLabelProps={{ shrink: true }}
                            error={!this.checkFieldsEqual() || this.state.password.length < 4}
                            type="password"
                            helperText={
                                this.getHelperInfo()
                            }
                            required={true}
                            // tslint:disable-next-line: jsx-no-lambda
                            onChange={(e) => this.setState({ passwordConfirm: e.target.value })}
                        />
                    </Grid>
                    <Grid item={true} xs={6} />
                    <Grid item={true} xs={6}>
                        <Button
                            classes={{ root: classes.submitButton }}
                            onClick={this.submit}
                            disabled={!this.checkFieldsEqual() || this.state.password.length < 4}
                            variant='contained'
                        >
                            Submit
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}

export default withStyles(styles, { withTheme: true })(
    ChangeUserPassword
);



// WEBPACK FOOTER //
// ./src/modules/admin/modules/UsersAdmin/components/ChangeUserPassword.tsx